import React, { useState, useEffect } from 'react';
import * as S from './ShopSkeleton.styles';

export const ShopInfoSkeleton: React.FC = () => {
  const getVisibleCount = () => {
    if (window.innerWidth <= 744) return 2;
    if (window.innerWidth <= 1100) return 4;
    return 5;
  };

  const [visibleCount, setVisibleCount] = useState(5);

  useEffect(() => {
    setVisibleCount(getVisibleCount());

    const handleResize = () => setVisibleCount(getVisibleCount());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <S.SkeletonWrapper>
      <S.SkeletonCover />

      <S.SkeletonTop>
        <S.SkeletonHeader>
          <S.SkeletonLeft>
            <S.SkeletonAvatar />
            <S.SkeletonTextGroup>
              <S.SkeletonLine $width="300px" />
              <S.SkeletonLine $width="200px" />
              <S.SkeletonLine $width="180px" />
            </S.SkeletonTextGroup>
          </S.SkeletonLeft>

          <S.SkeletonRightButton />
        </S.SkeletonHeader>

        <S.SkeletonPromoBlock>
          <S.SkeletonLine $width="300px" />
          <S.SkeletonLine $width="50%" $height="41px" />
          <S.SkeletonLine $width="110px" />
          <S.SkeletonLine $width="250px" />
        </S.SkeletonPromoBlock>

        <S.SkeletonGallery>
          {Array.from({ length: visibleCount }).map((_, i) => (
            <div key={i} />
          ))}
        </S.SkeletonGallery>
      </S.SkeletonTop>
    </S.SkeletonWrapper>
  );
};
